import {BaseComponentProcessor} from "@/components/DiagramDesigner/Editor/components/BaseComponentProcessor";
import {StorageNode} from "@/../../common/db/StorageNode"

export class ChatProcessor extends BaseComponentProcessor {

    /**
     * Processor constructor
     * @param props
     */
    constructor(...props) {
        super(...props);
    }

    /**
     * Get arguments
     */
    async getArguments() {
        // Load child diagram
        return await StorageNode.getArguments(this.context.module_id, 'diagram-'+this.block?.properties?.diagramId);
    }

}
